import { Inject, Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {VwSecDependencia} from "../../../../administracion/src/app/shared/interfaces/database/seguridad";
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class SecDependenciaService {
  readonly baseUrl: string;
  
  constructor(@Inject(API_URL) public apiUrl: string, private readonly http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/dependencia`;
  }

  getAllActivos(): Observable<VwSecDependencia[]> {
    const url = `${this.baseUrl}/public/activas`
    return this.http.get<VwSecDependencia[]>(url);
  }

}
